import AuthService from "../../AuthService";
const groupVisit = {
  getGroupVisit(page) {
    return AuthService.get("/service/group_visit?page=" + page);
  },
  showGroupVisit(id) {
    return AuthService.get("/service/group_visit/" + id);
  },
  createGroupVisit(data) {
    return AuthService.post("/service/group_visit", data);
  },
  updateGroupVisit(id, data) {
    return AuthService.put("/service/group_visit/" + id, data);
  },
  deleteGroupVisit(id) {
    return AuthService.delete("/service/group_visit/" + id);
  }
};
export default groupVisit;
